<template>
	<div class="c-health-check-tool__consent">
		<DsText html-element="h1" text-style="medium" text-type="heading-3xl" v-if="headline">
			{{ headline }}
		</DsText>
		<div class="c-health-check-tool__faq" v-if="faqArea1?.length">
			<FaqItem v-for="{ title, description, dsFaqIcon } in faqArea1" :key="title" :description="description"
				:ds-faq-icon="dsFaqIcon" :title="title">
			</FaqItem>
		</div>
		<DsText class="c-health-check-tool__body" html-element="div" text-style="medium" text-type="body-lg">
			<div v-html="bodyText"></div>
		</DsText>
		<div class="c-health-check-tool__faq" v-if="faqArea2?.length">
			<FaqItem v-for="{ title, description, dsFaqIcon } in faqArea2" :key="title" :description="description"
				:ds-faq-icon="dsFaqIcon" :title="title">
			</FaqItem>
		</div>
		<DsText class="c-health-check-tool__description" html-element="div" text-style="regular" text-type="body-md">
			<span v-html="consentDescription"></span>
		</DsText>
		<div class="c-health-check-tool__slide-actions">
			<DsButtonGroup mobile-direction="row" mobileAlignment="start">
				<DsIconButton
					icon-name="navigate-back"
					:aria-label="labels.prev"
					:clickHandler="prevStep"
				></DsIconButton>
				<DsButton variant="primary" icon-end="navigate-forward" @click="acceptConsent" tabindex="0">
					{{ acceptButtonText }}
				</DsButton>
			</DsButtonGroup>
		</div>
	</div>
</template>

<script setup lang="ts">
import { DsText, DsButton, DsIconButton, DsButtonGroup } from '@coloplast/design-system';
import type { ConsentForm } from '../HealthCheckTool.types';
import FaqItem from './faqItem.vue';

interface ButtonLabels {
	next?: string;
	prev?: string;
	submit?: string;
}

interface AdditionalConsentProps {
	labels: ButtonLabels;
}

defineProps<ConsentForm & AdditionalConsentProps>();

const emit = defineEmits<{
	(e: 'next'): void;
	(e: 'prev'): void;
	(e: 'consent', consent: boolean): void;
}>();

const prevStep = () => {
	emit('prev');
}

const acceptConsent = () => {
	emit('consent', true);
	emit('next');
};
</script>

<style lang="scss" scoped>
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';

.c-health-check-tool__slide-actions {
	width: 100%;

	& .ds-button-group {
		--flex-alignment: space-between;
	}
}

.c-health-check-tool__consent {
	display: flex;
	flex-direction: column;
	row-gap: ds-space(10);
}
</style>
